import useEDB from "$hooks/useEDB";
import useEDBProfile from "$hooks/useEDBProfile";
import useEDBIntegratedOrders from "$hooks/useEDBIntegratedOrders";
import { ProfileEDBExternalsTypes } from "../types/profileEDB.types";

type Props = {
  idEdb: string;
};

export default function useProfileEDBExternals({
  idEdb,
}: Props): ProfileEDBExternalsTypes {
  const {
    edb,
    statusEDB,
    canCreateOp,
    tInfoHeader,
    tInfoData,
    opList,
    isOpListLoaded,
    updateProductOPQty,
    handleChangeOP,
    handleCreateOP,
    onCancelOP,
    onDeleteOPItem,
    onDeleteEdb,
    onCancelEdb,
    onDeleteItemFromEdb,
    productEdbAddToOP,
    setProductEdbAddToOP,
    validateProductAddToOp,
    productToDeleteFromEdb,
    setProductToDeleteFromEdb,
    substituteProduct,
    substitutionProductEDB,
    fetchEdb,
    isLoading,
    setIsLoading,
    selectedSubstituteProduct,
    setSelectedSubstituteProduct,
    openModalSubstituteProduct,
    setOpenModalSubstituteProduct,
    productPopin,
    setProductPopin,
    produit,
    setProduit,
    formOpen,
    setFormOpen,
    isCreatingOp,
    isDisabled,
  } = useEDBProfile(idEdb);

  const {
    updateEDBProducts,
    updateEDB,
    saveEDB,
    isModifyingDelivery,
    setIsModifyingDelivery,
  } = useEDB();

  const {
    isLoadingIntegratedOrders,
    integratedOrders: fetchedIntegratedOrders,
    fetchIntegratedOrders,
    onDeleteIntegratedProduct,
  } = useEDBIntegratedOrders(edb?._id);

  return {
    edb,
    opList,
    produit,
    formOpen,
    isLoading,
    isDisabled,
    statusEDB,
    tInfoData,
    canCreateOp,
    tInfoHeader,
    productPopin,
    isCreatingOp,
    isOpListLoaded,
    productEdbAddToOP,
    isModifyingDelivery,
    productToDeleteFromEdb,
    fetchedIntegratedOrders,
    isLoadingIntegratedOrders,
    selectedSubstituteProduct,
    openModalSubstituteProduct,

    saveEDB,
    fetchEdb,
    updateEDB,
    setProduit,
    onCancelOP,
    onDeleteEdb,
    onCancelEdb,
    setFormOpen,
    setIsLoading,
    onDeleteOPItem,
    handleChangeOP,
    handleCreateOP,
    setProductPopin,
    substituteProduct,
    updateEDBProducts,
    updateProductOPQty,
    onDeleteItemFromEdb,
    setProductEdbAddToOP,
    fetchIntegratedOrders,
    substitutionProductEDB,
    validateProductAddToOp,
    setIsModifyingDelivery,
    setProductToDeleteFromEdb,
    onDeleteIntegratedProduct,
    setSelectedSubstituteProduct,
    setOpenModalSubstituteProduct,
  };
}
